import React, { useEffect, useMemo, useRef, useState } from 'react';

import { LoadingSpinner } from 'src/shared/components/common/loading_spinner/LoadingSpinner';

import config from 'config';

interface Location {
  lat: string;
  long: string;
}

interface Props {
  shouldShow: boolean;
  searchLocation?: Location
}

const CateringDiscover = ({ shouldShow, searchLocation }: Props) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [didLoadiFrame, setDidLoadiFrame] = useState(false);

  // Initialize query params only once so that we don't reload the iframe when search changes
  const queryParams = useMemo(() => {
    return new URLSearchParams({
      embedded: 'true',
      utm_source: 'toast_local_embedded',
      ...searchLocation
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [updatedSearch, setUpdatedSearch] = useState<Location | undefined>(searchLocation);

  useEffect(() => {
    try {
      iframeRef.current?.contentWindow?.postMessage(updatedSearch, config.resources.toastwebBaseUri);
    } catch(error) {
      console.error('Error posting message iframe:', error);
    }
  }, [updatedSearch]);

  // Update the search location in the iframe only if the catering page is showing
  // and when the value coming is actually different than the previous request
  useEffect(() => {
    const latChanged = searchLocation?.lat && searchLocation?.lat !== updatedSearch?.lat;
    const longChanged = searchLocation?.long && searchLocation?.long !== updatedSearch?.long;
    if(shouldShow && (latChanged || longChanged)) {
      setUpdatedSearch(searchLocation);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchLocation, shouldShow]);

  useEffect(() => {
    document.body.style.overflow = shouldShow ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [shouldShow]);

  if(!shouldShow && !didLoadiFrame) {
    return null;
  }

  return (
    <div className="catering-container">
      {!didLoadiFrame &&
        <div className="catering-loading-overlay" data-testid="catering-loading-spinner">
          <LoadingSpinner color={'#C0C0C0'} strokeWidth={1} />
        </div>}
      <iframe
        ref={iframeRef}
        title="Catering Discover"
        className="catering-iframe"
        data-testid="catering-iframe"
        style={{ display: shouldShow ? 'inline' : 'none' }}
        tabIndex={-1}
        onLoad={() => setDidLoadiFrame(true)}
        src={`${config.resources.toastwebBaseUri}catering/locations/discover?${queryParams.toString()}`} />
    </div>
  );
};

export default CateringDiscover;
